import { useAuthStore } from '../stores/auth.store'
import { QrCode, LogOut, User } from 'lucide-react'
import './Layout.scss'

interface LayoutProps {
  children: React.ReactNode
}

export function Layout({ children }: LayoutProps) {
  const { user, signOut } = useAuthStore()

  return (
    <div className="layout">
      <header className="header">
        <div className="header-left">
          <QrCode size={28} />
          <h1>QR Maker</h1>
        </div>
        <div className="header-right">
          {user && (
            <>
              <div className="user-info">
                {user.avatarUrl ? (
                  <img src={user.avatarUrl} alt={user.fullName} className="avatar" />
                ) : (
                  <div className="avatar-placeholder">
                    <User size={16} />
                  </div>
                )}
                <span className="user-name">{user.fullName}</span>
              </div>
              <button className="sign-out-btn" onClick={signOut} title="Sign out">
                <LogOut size={18} />
              </button>
            </>
          )}
        </div>
      </header>
      <main className="main">{children}</main>
    </div>
  )
}
